import { useRef, useEffect } from 'react';

/**
Un hook che mantiene il posizionamento del selettore in un input.
 * @param {node} ref input ref.
 * @param {string} value valore del'input che cambia.
 */
const useRefWithSelectionRange = (ref, value, enableUpdateSelector) => {
    const targetInfo = useRef();
    const handleBeforeInput = (event) => {
        const target = event.target;
        targetInfo.current = {
            selectionEnd: target.selectionEnd || 0,
            length: target.value ? target.value.length : 0,
        };
    };
    useEffect(() => {
        if (!enableUpdateSelector)
            return;
        requestAnimationFrame(() => {
            if (ref.current && targetInfo.current) {
                const { selectionEnd, length } = targetInfo.current;
                const updatedLength = ref.current.value ? (ref.current.value.length - length) : 0;
                const updatedSelectionEnd = selectionEnd + updatedLength;
                ref.current.setSelectionRange(updatedSelectionEnd, updatedSelectionEnd);
            }
        });
    }, [enableUpdateSelector, ref, value]);
    useEffect(() => {
        if (!enableUpdateSelector)
            return () => { };
        const currentRef = ref.current;
        currentRef === null || currentRef === void 0 ? void 0 : currentRef.addEventListener('beforeinput', handleBeforeInput);
        return () => {
            currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('beforeinput', handleBeforeInput);
        };
    }, [enableUpdateSelector, ref]);
};

export { useRefWithSelectionRange as default };
